import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react'

import { ScreenContext } from 'src/context/screenContext'

export const NavigatorContext = createContext({
    sidebarCollapsed: true,
    setSidebarCollapsed: () => {},
    overlayVisible: false,
    setOverlayVisible: (_visible) => {},
    toggleSidebar: (_on) => {},
})

NavigatorContext.displayName = 'NavigatorContext'

const SIDEBAR_KEYBOARD_SHORTCUT = 'b'

export const NavigatorContextProvider = ({ children }) => {
    const { isSmallScreen } = useContext(ScreenContext)
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        return localStorage.getItem('sidebarCollapsed')
            ? Boolean(JSON.parse(localStorage.getItem('sidebarCollapsed')))
            : true
    })

    useEffect(() => {
        localStorage.setItem('sidebarCollapsed', sidebarCollapsed.toString())
    }, [sidebarCollapsed])

    const [overlayVisible, setOverlayVisible] = useState(false)

    const toggleSidebar = useCallback(() => {
        setSidebarCollapsed((prev) => !prev)
    }, [])

    // Adds a keyboard shortcut to toggle the sidebar.
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (
                event.key === SIDEBAR_KEYBOARD_SHORTCUT &&
                (event.metaKey || event.ctrlKey)
            ) {
                event.preventDefault()
                toggleSidebar()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [toggleSidebar])

    useEffect(() => {
        if (!isSmallScreen) {
            setOverlayVisible(false)
            return
        }

        if (!sidebarCollapsed) {
            setOverlayVisible(true)
        } else {
            setOverlayVisible(false)
        }
    }, [sidebarCollapsed, isSmallScreen])

    return (
        <NavigatorContext.Provider
            value={{
                sidebarCollapsed,
                setSidebarCollapsed,
                toggleSidebar,
                overlayVisible,
                setOverlayVisible,
            }}
        >
            {children}
        </NavigatorContext.Provider>
    )
}
